/**
 * Aimtec DI
 * For more information visit the documentation <a href=\"%documentationUrl%\" target=\"_blank\">here</a>.
 *
 * The version of the OpenAPI document: {Version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum RunDirectionType {
    Import = 'Import',
    Export = 'Export'
}

